export default "__VITE_ASSET__Dd95h_mj__"